import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

import { setEditingOnTicket } from "../../../../../actions/projectmail";

const EditModalWarningComponent = ({ row, setOpenModal, openModal, setEditingOnTicketFn, translate }) => {
  const theme = useTheme();
  const modalSx = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const modalContainerSx = {
    width: "700px",
    backgroundColor: "#eee",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    p: 2,
  };
  const inlineSx = {
    display: "flex",
    maxWidth: "100%",
    flexWrap: "wrap",
  };
  const bottomPaddingSx = { pb: 1 };
  const contentSx = { p: 1 };
  const buttonSx = { p: theme.spacing(0, 1) };
  const spaceButtonsSx = { flex: 1 };
  const modalTitleSx = { fontWeight: "bold", fontSize: "20px" };

  return (
    <Modal key="Email-Ticket-System-Modal" open={openModal} sx={modalSx} onClose={() => setOpenModal(false)}>
      <Fade in={openModal}>
        <Box key="modalContainer" sx={modalContainerSx}>
          <Paper>
            <Box sx={contentSx}>
              <Box sx={modalTitleSx}>{translate.warning}</Box>
              <Box sx={bottomPaddingSx} />
              <div>{translate.isUserAssigned.replace("{0}", row.owner)}</div>
              <div>{translate.overrideAssign}</div>
            </Box>
          </Paper>
          <Box sx={bottomPaddingSx} />
          <Box sx={inlineSx}>
            <Box sx={buttonSx}>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={() => {
                  setEditingOnTicketFn(row.id);
                  window.open("https://zammad.ubivent.net/#ticket/zoom/" + row.id, "zammad");
                  setOpenModal(false);
                }}
              >
                {translate.yes}
              </Button>
            </Box>
            <Box sx={buttonSx}>
              <Button
                size="small"
                color="secondary"
                variant="contained"
                onClick={() => {
                  window.open("https://zammad.ubivent.net/#ticket/zoom/" + row.id, "zammad");
                  setOpenModal(false);
                }}
              >
                {translate.no}
              </Button>
            </Box>
            <Box sx={spaceButtonsSx} />
            <Box sx={buttonSx}>
              <Button
                size="small"
                onClick={() => {
                  setOpenModal(false);
                }}>
                {translate.cancel}
              </Button>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

EditModalWarningComponent.propTypes = {
  translate: PropTypes.object.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  openModal: PropTypes.bool.isRequired,
  setEditingOnTicketFn: PropTypes.func.isRequired,
  row: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  translate: state.ui.translate,
});

const mapDispatchToProps = dispatch => ({
  setEditingOnTicketFn: id => dispatch(setEditingOnTicket(id, true)),
});

const EditModalWarning = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditModalWarningComponent);

export default EditModalWarning;
